import { Form, Button } from "antd";
import { handleLogin } from "../security/ToggleViews";

export const PublicLandingView = () => {

  return (
    <>
      <div className="login-pf-page">
        <div>
          {/* <div class="seims-login-card-background"> */}
          <div className="card-pf">
            <img
              className="seims-logo"
              style={{ margin: "0px auto", display: "block" }}
              src={require("../assets/seims-logo.png")}
              alt="SEIMS"
            />
            <header className="login-pf-header">
              <h1 id="kc-page-title">Welcome to SEIMS Portal</h1>
            </header>
            <div id="kc-content">
              <div id="kc-content-wrapper">
                <div id="kc-form">
                  <div id="kc-form-wrapper">
                    <Form.Item style={{ marginBottom: 0 }}>
                      <Button
                        type="primary"
                        className="pf-c-button pf-m-primary pf-m-block btn-lg register-form-buttons"
                        // onClick={login}
                        onClick={handleLogin}
                        data-testid="test-login-button"
                      >
                        Login
                      </Button>
                    </Form.Item>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* </div> */}
        </div>
      </div>
    </>
  );
};
